import styles from './ImageCard.module.scss';
import React from 'react';
import classNames from 'classnames';
import { IconCard, Image } from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';

const ImageCard = ({
  as: Tag = 'div',
  icon,
  title,
  description,
  image,
  headingLevel = 3,
  action,
  className,
  onClick,
  type,
}) => (
  <Tag
    className={classNames(styles.container, className)}
    onClick={onClick}
    target={action?.target || '_self'}
    title={action?.title}
    to={action?.url}
  >
    <Image
      alt={image?.title}
      className={styles.image}
      sizes={image?.sizes}
      src={image?.src}
      srcSet={image?.srcSet}
      title={image?.title}
    />
    <div
      className={classNames(styles.cardWrapper, {
        [styles.imageCard]: type === 'imageCard',
      })}
    >
      <IconCard
        button={type === 'contentCard' ? action : undefined}
        description={description}
        glyph={!icon?.src ? icon : null}
        hasAction={type !== 'contentCard' && !!action}
        headingLevel={headingLevel}
        headingSize="h4"
        icon={icon?.src}
        limitText={210}
        title={title}
        type={type}
        variant="iconTop"
      />
    </div>
  </Tag>
);

ImageCard.propTypes = {
  action: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.string,
  }),
  as: PropTypes.elementType,
  className: PropTypes.string,
  description: PropTypes.string,
  headingLevel: PropTypes.number,
  icon: PropTypes.shape({ src: PropTypes.string }),
  image: PropTypes.shape({
    title: PropTypes.string,
    alt: PropTypes.string,
    sizes: PropTypes.string,
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
  }),
  onClick: PropTypes.func,
  title: PropTypes.string,
  type: PropTypes.oneOf(['contentCard', 'imageCard']).isRequired,
};

export default ImageCard;
